import AirportAPI from 'api/airport';
import SearchUtils from 'utils/search-utils';
import CMSUtils from 'utils/cms';
import {PRISMIC_CUSTOM_TYPE} from 'utils/prismic-types';
import {Page, fetchCity, parseSlug} from 'utils/page-utils';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';
import AppRatingAPI from 'api/app-rating';

const getInitialState = async ({state, cookies, params}) => {
    const pageType = Page.AIRPORT;
    const citySlug = params.city;
    const code = parseSlug(params.slug);
    const city = await fetchCity(state, citySlug);
    const {
        data: {timezone},
    } = city;

    const [page, destination, appRating] = await Promise.all([
        CMSUtils.getPageData({
            cookies,
            slug: code,
            city,
            customType: PRISMIC_CUSTOM_TYPE.AIRPORT_MIDFUNNEL,
            pageType,
        }),
        AirportAPI.getByCode(code).then(res => res.data),
        AppRatingAPI.get(),
    ]);

    const searchRequest = {
        ...searchRequestInitialState,
        pageType,
        ...SearchUtils.createTimeWindowParams(pageType, {}, timezone),
    };

    return {
        ...state,
        city,
        destination,
        searchRequest,
        page,
        appRating: {...appRating, isPending: false},
    };
};

export default getInitialState;
